import { DATA_INSIGHTS_API } from './baseUrl'

export const LOGIN_URL = `${DATA_INSIGHTS_API}auth/token/`
export const REFRESH_TOKEN_URL = `${DATA_INSIGHTS_API}auth/token/refresh/`
